<script>
    import PreviewSection from "./PreviewSection";
    import SubscriptionOverviewSection from "../../components/pagesbuilder/sections/SubscriptionOverviewSection";

    export default {
        name: "PreviewSubscriptionOverviewSection",
        mixins: [PreviewSection, SubscriptionOverviewSection]
    }
</script>
